import PropTypes from 'prop-types';
// material
import { Paper, Typography } from '@mui/material';

// ----------------------------------------------------------------------

SearchNotFound.propTypes = {
  searchQuery: PropTypes.string
};

export default function SearchNotFound({ searchQuery = '', ...other }) {
  return (
    <Paper {...other}>
      <Typography gutterBottom align="center" variant="subtitle1">
        沒有搜尋到結果
      </Typography>
      <Typography variant="body2" align="center">
        沒有條件符合 &nbsp;
        <strong>&quot;{searchQuery}&quot;</strong>. 請給重新試試或打出更完整文字
      </Typography>
    </Paper>
  );
}
